/*
 * Copyright (c) 2021-2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: Editor.ts
 * Project: mle-client
 * Committed last: 2021/11/12 @ 847
 * ---
 */

import axios            from 'axios';
import { TokenService } from './token.service';
import { message }      from 'antd';
import { urlProvider }  from '../url/UrlProviderInstanceManager';

/**
 * Istanza del client HTTP (REST).
 * Imposta il baseUrl per evitarne la ripetizione ad ogni chiamata e riporta
 * la necessità di credenziali associate alle stesse.
 * @type {AxiosInstance}
 */
export const mleAuthProviderRestClient = axios.create({
  baseURL: urlProvider.getApUrl(),
  withCredentials: true
});

/**
 * Popola ad ogni chiamata l'header di autorizzazione con l'accessToken
 * fornito dal relativo servizio
 */
mleAuthProviderRestClient.interceptors.request.use(
  (config) => {
    const accessToken = TokenService.getInstance().getAccessToken();
    if (config.headers)
      config.headers['Authorization'] = `Bearer ${ accessToken }`;

    return config;
  },
  (error) => {
    /**
     * Nel caso anche la chiamata con token non vada a buon fine, rilancia l'errore
     */
    Promise.reject(error).then(() => message.error('Errore non intercettato'));
  }
);